import { render } from "./LeistungsberechnungGleichstrom.vue?vue&type=template&id=b83a94c6"
import script from "./LeistungsberechnungGleichstrom.vue?vue&type=script&lang=js"
export * from "./LeistungsberechnungGleichstrom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__